export const SnackbarColor = {
  blue: 'blue',
  green: 'green',
  red: 'red',
  purple: 'purple',
  gold: 'gold',
} as const;
export type SnackbarColor = keyof typeof SnackbarColor;

export const SnackbarType = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
  agent: 'agent',
} as const;
export type SnackbarType = keyof typeof SnackbarType;
